import Message from 'carbon-react/lib/components/message';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const SyncErrorMessage = () => (
  <div data-testid="syncing-message" style={{ marginBottom: 24 }}>
    <Message
      variant="error"
      title={<FormattedMessage id="datasource.data_sync_failed" defaultMessage="Data sync failed" />}
    >
      <FormattedMessage
        id="predict.last_sync_failure"
        defaultMessage="The last sync we tried was unsuccessful. Please try again. If the issue persists please contact support"
      />
    </Message>
  </div>
);
